import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaPhoneAlt, FaEnvelope } from 'react-icons/fa';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <>
      {/* Top Contact Banner */}
      <div className="top-banner">
        <a href="tel:+16199959636" className="banner-link">
          <FaPhoneAlt className="banner-icon" />
          +1 (619) 995-9636
        </a>
        <a href="mailto:info@king3dmfg.com" className="banner-link">
          <FaEnvelope className="banner-icon" />
          info@king3dmfg.com
        </a>
      </div>

      {/* Main Header */}
      <header className="header">
        <div className="header-container">
          {/* Logo */}
          <Link to="/" className="logo-link">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo_transparent.png`}
              alt="KING3DMFG Logo"
              className="logo"
            />
          </Link>

          {/* Hamburger Icon */}
          <div className="menu-icon" onClick={toggleMenu}>
            <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
            <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
            <div className={`bar ${menuOpen ? 'open' : ''}`}></div>
          </div>

          {/* Navigation */}
          <nav className={`nav-menu ${menuOpen ? 'active' : ''}`}>
            <ul>
              <li>
                <Link to="/" onClick={toggleMenu}>Home</Link>
              </li>
              <li>
                <Link to="/services" onClick={toggleMenu}>Services</Link>
              </li>
              <li>
                <Link to="/products" onClick={toggleMenu}>Products</Link>
              </li>
              <li>
                <Link to="/about" onClick={toggleMenu}>About</Link>
              </li>
            </ul>
          </nav>

          {/* CTA Button */}
          <div className="header-cta">
            <button
              type="button"
              className="cta-button"
              onClick={() => {
                const el = document.getElementById('quote-form');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Contact Us
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
